import { takeLatest, put, call } from 'redux-saga/effects';
import * as actionTypes from './actions';
import { simplePost } from '../../utils/requests';
import pathconfig from '../../utils/path-config';

function* forgotUsername(params) {
  try {
    let result = yield call(simplePost, pathconfig.forgotUsername, params.params);
    yield put({ type: actionTypes.FORGOT_USERNAME_RESPONSE, forgotUsernameResponse: result })
  } catch (err) {
    console.log(err)
  }
}

export default function* watchLoginSaga() {
  yield takeLatest(actionTypes.FORGOT_USERNAME, forgotUsername);
}